import type { ReactNode } from "react";

import Menu from "@/components/Menu";

import LanguageSwitcher from "../components/LanguageSwitcher";

import "./Layout.module.css";

type SurveyLayoutProps = {
  children: ReactNode;
};

const SurveyLayout = ({ children }: SurveyLayoutProps) => {
  return (
    <div className="app w-[100%] max-w-[834px] flex flex-col mx-auto bg-[#002558]">
      <div className="sm:overflow-x-hidden bg-white grow flex flex-col">
        <Menu />
        {children}
        <LanguageSwitcher />
      </div>
    </div>
  );
};

export default SurveyLayout;
